"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4991],{

/***/ 39055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path, _path2;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgEarth = function SvgEarth(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20"
    }, props), _path || (_path = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        stroke: "#323338",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M10 19a9 9 0 1 0 0-18 9 9 0 0 0 0 18"
    })), _path2 || (_path2 = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        stroke: "#323338",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M7.831 18.737C6.613 16.95 5.8 13.707 5.8 10s.813-6.951 2.031-8.737M1 10h18M2.386 14.8h15.229M2.386 5.2h15.229M12.169 1.263C13.386 3.05 14.2 6.293 14.2 10s-.813 6.951-2.031 8.737"
    })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgEarth);


/***/ }),

/***/ 48124:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ core_addons_component; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/ouibounce/build/ouibounce.js
var ouibounce = __webpack_require__(5499);
var ouibounce_default = /*#__PURE__*/__webpack_require__.n(ouibounce);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
;// CONCATENATED MODULE: ./components/addons/exit-popup/exit-popup-constants.js
var EXIT_POPUP_TEXT = {
    en: {
        TITLE: '"I want to hug the people that created this."',
        SUBTITLE: "- Emma J Coulson, with monday.com since 2014",
        SIGNUP_HEADER_TEXT: "Join 15,000+ teams who are passionate about monday.com",
        SIGNUP_INPUT_PLACEHOLDER: "Enter your work email",
        SIGNUP_BUTTON_TEXT: "Get free access now",
        SIGNUP_FOOTER_TEXT: "No thanks"
    },
    fr: {
        TITLE: "Vous n'avez pas le temps... Nous comprenons :)",
        SUBTITLE: "Envoyez-vous une invitation maintenant, et d\xe9butez quand vous avez 3 minutes",
        SIGNUP_INPUT_PLACEHOLDER: "Entrez votre adresse e-mail",
        SIGNUP_BUTTON_TEXT: "m'inviter"
    },
    es: {
        TITLE: "Est\xe1s ocupado... Te entendemos :)",
        SUBTITLE: "Env\xedate una invitaci\xf3n ahora y prueba monday.com cuando tengas 3 minutos",
        SIGNUP_INPUT_PLACEHOLDER: "Ingresa tu correo laboral",
        SIGNUP_BUTTON_TEXT: "Enviar"
    },
    de: {
        TITLE: "Du bist besch\xe4ftigt… wir verstehen das :)",
        SUBTITLE: "Sende dir jetzt selbst eine Einladung und probiere uns aus, wenn 3 Minuten Zeit hast",
        SIGNUP_INPUT_PLACEHOLDER: "Ihre Firmen-E-Mail-Adresse",
        SIGNUP_BUTTON_TEXT: "Mich selbst einladen"
    },
    it: {
        TITLE: "Sei impegnato... ti capiamo :)",
        SUBTITLE: "Mandati un auto-invito, e mettici alla prova quando hai 3 minuti liberi",
        SIGNUP_INPUT_PLACEHOLDER: "Inserisci la tua email aziendale",
        SIGNUP_BUTTON_TEXT: "Invita Me Stesso"
    }
};
var EXIT_POPUP_ORIGIN = "hp_exit_intent_modal";

// EXTERNAL MODULE: ./constants/cookies.js
var cookies = __webpack_require__(13019);
// EXTERNAL MODULE: ./services/ab-tests/acquisition-ab-test-service.js
var acquisition_ab_test_service = __webpack_require__(77784);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
;// CONCATENATED MODULE: ./components/enhancements/modal-background/modal-background-component.scss.js



var StyledModalBackgroundComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ebjt820"
})("position:fixed;width:100%;height:100%;background-color:", colors/* default.black */.Z.black, ";opacity:0.9;top:0;left:0;z-index:", z_index/* MODAL_BACKGROUND */.AE, ";");

;// CONCATENATED MODULE: ./components/enhancements/modal-background/modal-background-component.js


var ModalBackgroundComponent = function(props) {
    var onClick = props.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledModalBackgroundComponent, {
        className: "modal-background",
        onClick: onClick
    });
};
/* harmony default export */ var modal_background_component = (ModalBackgroundComponent);

// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(60357);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./components/core/signups/base-signup-form/signup-form-component.js + 2 modules
var signup_form_component = __webpack_require__(24494);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/addons/exit-popup/exit-popup-signup/exit-popup-signup-component.scss.js


var componentStyle = new String(".header-text.jsx-fb833f46e36abbce{margin-bottom:16px}");
componentStyle.__hash = "fb833f46e36abbce";
var signupBoxStyle = new String(".exit-popup-signup{.footer-text{cursor:pointer;color:darken(#fff,10%)}.exit-popup-signup-box{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;.signup-form{margin-bottom:16px;margin-top:0}.signup-input{height:56px;width:224px;padding:0 24px;-webkit-border-radius:50px 0 0 50px;-moz-border-radius:50px 0 0 50px;border-radius:50px 0 0 50px;border:1px solid transparent;margin-right:0;color:".concat(colors/* default.black */.Z.black, ";vertical-align:bottom;font-size:.875rem;&:focus{outline:0}}.signup-button{height:56px;min-width:200px;background:#f4ce2f;-webkit-border-radius:0 50px 50px 0;-moz-border-radius:0 50px 50px 0;border-radius:0 50px 50px 0;border:1px solid transparent;padding:0 10px;color:#333;font-size:.875rem;vertical-align:bottom;&:hover{background:darken(#f4ce2f,5%);border:#f4ce2f}}}}@media(max-width:").concat(vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){.exit-popup-signup{.exit-popup-signup-box .signup-form-core-component-wrapper form{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;.signup-button-wrapper{width:auto;padding:8px 0 16px 0}}}}"));
signupBoxStyle.__hash = "98a26903dd2c2d5b";

;// CONCATENATED MODULE: ./components/addons/exit-popup/exit-popup-signup/exit-popup-signup-component.js











var ExitPopupSignup = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ExitPopupSignup, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ExitPopupSignup);
    function ExitPopupSignup(props) {
        (0,_class_call_check/* default */.Z)(this, ExitPopupSignup);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            value: ""
        };
        _this.onInputChange = _this.onInputChange.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(ExitPopupSignup, [
        {
            key: "onInputChange",
            value: function onInputChange(e) {
                var value = e.target.value.value;
                this.setState({
                    value: value
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, headerText = _props.headerText, inputPlaceholder = _props.inputPlaceholder, buttonText = _props.buttonText, footerText = _props.footerText, origin = _props.origin, onClickFooterText = _props.onClickFooterText;
                var value = this.state.value;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "jsx-".concat(signupBoxStyle.__hash, " jsx-").concat(componentStyle.__hash) + " " + "exit-popup-signup",
                    children: [
                        headerText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(signupBoxStyle.__hash, " jsx-").concat(componentStyle.__hash) + " " + "header-text",
                            children: headerText
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(signupBoxStyle.__hash, " jsx-").concat(componentStyle.__hash) + " " + "exit-popup-signup-box",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_form_component/* default */.Z, {
                                placeholder: inputPlaceholder,
                                ctaText: buttonText,
                                useCtaText: !!buttonText,
                                origin: origin,
                                forceDefaultForm: true
                            })
                        }),
                        footerText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            onClick: onClickFooterText,
                            className: "jsx-".concat(signupBoxStyle.__hash, " jsx-").concat(componentStyle.__hash) + " " + "footer-text",
                            children: footerText
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: componentStyle.__hash,
                            children: componentStyle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: signupBoxStyle.__hash,
                            children: signupBoxStyle
                        })
                    ]
                });
            }
        }
    ]);
    return ExitPopupSignup;
}(react.PureComponent);

ExitPopupSignup.defaultProps = {
    headerText: "Join <monday-paying-companies />+ teams who are passionate about monday.com",
    buttonText: "Get free access now",
    inputPlaceholder: "Enter your work email",
    footerText: "No thanks"
};

;// CONCATENATED MODULE: ./components/addons/exit-popup/exit-popup-content/exit-popup-content-component.scss.js


var exit_popup_content_component_scss_componentStyle = new String(".exit-popup-content-component.jsx-c4034e412f97cb55{position:fixed;z-index:".concat(z_index/* MODAL_BACKGROUND */.AE + 1, ";left:50%;top:50%;-webkit-transform:translate(-50%,-50%);-moz-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);-o-transform:translate(-50%,-50%);transform:translate(-50%,-50%);width:720px;padding:56px 40px 40px 40px;-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;background:#333;color:#fff;text-align:center;.content-title.jsx-c4034e412f97cb55{font-size:3vw;font-weight:500;margin:0}.content-subtitle.jsx-c4034e412f97cb55{font-size:1.2vw;margin-bottom:56px}}"));
exit_popup_content_component_scss_componentStyle.__hash = "c4034e412f97cb55";
var closeIconStyle = new String(".exit-popup-close.jsx-76784fb04befc36c{position:absolute;top:0;right:0;width:60px;height:60px;background:-webkit-linear-gradient(45deg,#787878 0%,#787878 50%,#343434 50%,#222 61%);background:-moz-linear-gradient(45deg,#787878 0%,#787878 50%,#343434 50%,#222 61%);background:-o-linear-gradient(45deg,#787878 0%,#787878 50%,#343434 50%,#222 61%);background:linear-gradient(45deg,#787878 0%,#787878 50%,#343434 50%,#222 61%);-webkit-border-radius:0px 0px 0px 5px;-moz-border-radius:0px 0px 0px 5px;border-radius:0px 0px 0px 5px;.x-button.jsx-76784fb04befc36c{position:absolute;-webkit-transform:rotate(45deg);-moz-transform:rotate(45deg);-ms-transform:rotate(45deg);-o-transform:rotate(45deg);transform:rotate(45deg);top:-4px;right:4px;line-height:1;font-size:2.25rem;color:#787878;-webkit-transition:color.1s ease-in-out;-moz-transition:color.1s ease-in-out;-o-transition:color.1s ease-in-out;transition:color.1s ease-in-out;text-decoration:none;cursor:pointer;&.jsx-76784fb04befc36c:hover,&.jsx-76784fb04befc36c:active,&.jsx-76784fb04befc36c:focus{color:#c4c4c4;text-decoration:none}}}");
closeIconStyle.__hash = "76784fb04befc36c";

;// CONCATENATED MODULE: ./components/addons/exit-popup/exit-popup-content/exit-popup-content-component.js









var ExitPopupContent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ExitPopupContent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ExitPopupContent);
    function ExitPopupContent() {
        (0,_class_call_check/* default */.Z)(this, ExitPopupContent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(ExitPopupContent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, title = _props.title, subtitle = _props.subtitle, signupHeaderText = _props.signupHeaderText, singupInputPlaceholder = _props.singupInputPlaceholder, signupButtonText = _props.signupButtonText, signupFooterText = _props.signupFooterText, onClose = _props.onClose, origin = _props.origin;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "jsx-".concat(closeIconStyle.__hash, " jsx-").concat(exit_popup_content_component_scss_componentStyle.__hash) + " " + "exit-popup-content-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(closeIconStyle.__hash, " jsx-").concat(exit_popup_content_component_scss_componentStyle.__hash) + " " + "exit-popup-close",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                rel: "nofollow",
                                onClick: onClose,
                                className: "jsx-".concat(closeIconStyle.__hash, " jsx-").concat(exit_popup_content_component_scss_componentStyle.__hash) + " " + "x-button pointer tc",
                                children: "+"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "jsx-".concat(closeIconStyle.__hash, " jsx-").concat(exit_popup_content_component_scss_componentStyle.__hash) + " " + "content-title",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "jsx-".concat(closeIconStyle.__hash, " jsx-").concat(exit_popup_content_component_scss_componentStyle.__hash) + " " + "content-subtitle",
                            children: subtitle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ExitPopupSignup, {
                            headerText: signupHeaderText,
                            inputPlaceholder: singupInputPlaceholder,
                            buttonText: signupButtonText,
                            footerText: signupFooterText,
                            onClickFooterText: onClose,
                            origin: origin
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: exit_popup_content_component_scss_componentStyle.__hash,
                            children: exit_popup_content_component_scss_componentStyle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: closeIconStyle.__hash,
                            children: closeIconStyle
                        })
                    ]
                });
            }
        }
    ]);
    return ExitPopupContent;
}(react.PureComponent);


// EXTERNAL MODULE: ./constants/localized-number-of-customers.js
var localized_number_of_customers = __webpack_require__(2522);
;// CONCATENATED MODULE: ./components/addons/exit-popup/exit-popup-component.js


















var ExitPopup = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ExitPopup, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ExitPopup);
    function ExitPopup(props) {
        (0,_class_call_check/* default */.Z)(this, ExitPopup);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            isOpen: false
        };
        _this._ouibounce = null;
        _this.onExitIntent = _this.onExitIntent.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.onClose = _this.onClose.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(ExitPopup, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.initOuibounce();
            }
        },
        {
            key: "initOuibounce",
            value: function initOuibounce() {
                var _props = this.props, timer = _props.timer, aggressive = _props.aggressive, sensitivity = _props.sensitivity, delay = _props.delay, cookieExpire = _props.cookieExpire, cookieDomain = _props.cookieDomain, cookieName = _props.cookieName;
                this._ouibounce = ouibounce_default()(false, {
                    timer: timer,
                    aggressive: aggressive,
                    sensitivity: sensitivity,
                    delay: delay,
                    cookieExpire: cookieExpire,
                    cookieDomain: cookieDomain,
                    cookieName: cookieName,
                    callback: this.onExitIntent
                });
            }
        },
        {
            key: "onExitIntent",
            value: function onExitIntent() {
                var abTests = this.props.abTests;
                if (!(0,acquisition_ab_test_service.shouldSeeReviveExitPopupAbTest)(abTests, true)) return;
                this.props.onExitIntentCallback && this.props.onExitIntentCallback();
                this.setState({
                    isOpen: true
                });
                (0,bigbrain_service.trackEvent)(bigbrain_event_types.EXIT_POPUP_OPEN);
            }
        },
        {
            key: "onClose",
            value: function onClose() {
                this.props.onCloseExitPopupCallback && this.props.onCloseExitPopupCallback();
                this.setState({
                    isOpen: false
                });
                (0,bigbrain_service.trackEvent)(bigbrain_event_types.EXIT_POPUP_CLOSE);
            }
        },
        {
            key: "render",
            value: function render() {
                var isOpen = this.state.isOpen;
                var _props = this.props, title = _props.title, subtitle = _props.subtitle, signupConfig = _props.signupConfig, translate = _props.translate, translateWithParam = _props.translateWithParam, localeId = _props.localeId;
                var titleToUse = title || translate("exitPopup.title");
                var subtitleToUse = subtitle || translate("exitPopup.subtitle");
                var signupHeaderTextToUse = signupConfig && signupConfig.headerText || translateWithParam("exitPopup.signupTitle", (0,localized_number_of_customers/* getLocalizedNumberOfPayingTeams */.i)(localeId));
                var inputPlaceholderToUse = signupConfig && signupConfig.inputPlaceholder || translate("exitPopup.signupInputPlaceholder");
                var buttonTextToUse = signupConfig && signupConfig.buttonText || translate("exitPopup.signupButtonText");
                var footerTextToUse = signupConfig && signupConfig.footerText || translate("exitPopup.footerText");
                return isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "exit-popup-overlay",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_background_component, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ExitPopupContent, {
                            title: titleToUse,
                            subtitle: subtitleToUse,
                            signupHeaderText: signupHeaderTextToUse,
                            singupInputPlaceholder: inputPlaceholderToUse,
                            signupButtonText: buttonTextToUse,
                            signupFooterText: footerTextToUse,
                            onClose: this.onClose,
                            origin: EXIT_POPUP_ORIGIN
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
            }
        }
    ]);
    return ExitPopup;
}(react.PureComponent);
ExitPopup.defaultProps = {
    timer: 100,
    aggressive: false,
    sensitivity: 5,
    delay: 200,
    cookieExpire: 30,
    cookieDomain: ".monday.com",
    cookieName: cookies.VIEWED_OUI_BOUNCE_MODAL_COOKIE
};
/* harmony default export */ var exit_popup_component = ((0,ab_tests_context/* withAbTests */.k)((0,generic_config_context/* withGenericConfig */.P)(ExitPopup)));

// EXTERNAL MODULE: ./client/services/gtm-service/gtm-service.js
var gtm_service = __webpack_require__(60775);
// EXTERNAL MODULE: ./constants/data-layer-event-types.js
var data_layer_event_types = __webpack_require__(34496);
var data_layer_event_types_default = /*#__PURE__*/__webpack_require__.n(data_layer_event_types);
;// CONCATENATED MODULE: ./components/addons/core-addons/core-addons-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}







var CoreAddonsComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(CoreAddonsComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(CoreAddonsComponent);
    function CoreAddonsComponent() {
        (0,_class_call_check/* default */.Z)(this, CoreAddonsComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(CoreAddonsComponent, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                //TODO: Remove and change GTM trigger to page load
                (0,gtm_service/* fireGtmEvent */.k2)((data_layer_event_types_default()).SHOW_COOKIEHUB_DIALOG_EVENT_NAME);
            //If we see that CookieHub Geolocation isn't working well we can fire a GTM event only for relevant countries + another for the rest to launch all cookies
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, exitPopup = _props.exitPopup, exitPopupConfig = _props.exitPopupConfig;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                    children: exitPopup && /*#__PURE__*/ (0,jsx_runtime.jsx)(exit_popup_component, _object_spread({}, exitPopupConfig))
                });
            }
        }
    ]);
    return CoreAddonsComponent;
}(react.PureComponent);
/* harmony default export */ var core_addons_component = ((0,ab_tests_context/* withAbTests */.k)((0,generic_config_context/* withGenericConfig */.P)(CoreAddonsComponent)));


/***/ }),

/***/ 83971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "QS": function() { return /* binding */ LOGO_COMPANY_FIELDS; },
/* harmony export */   "WX": function() { return /* binding */ SUPPORTED_LOGOS_NUMBER_FOR_NARROW_DISPLAY_OPTIONS; },
/* harmony export */   "X$": function() { return /* binding */ NUMBER_OF_COMPANIES; },
/* harmony export */   "kZ": function() { return /* binding */ LOGO_COMPANY_COUNTRIES; },
/* harmony export */   "ly": function() { return /* binding */ SUPPORTED_LOGOS_NUMBER_OPTIONS; },
/* harmony export */   "yA": function() { return /* binding */ getCompaniesAssets; }
/* harmony export */ });
/* unused harmony exports ISO2_TO_LOGO_COUNTRIES_MAP, getPersonalizedLogosByVisitorCountryIfNeeded */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29815);
/* harmony import */ var lodash_union__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93386);
/* harmony import */ var lodash_union__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_union__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var services_countries_countries_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85010);
/* harmony import */ var services_countries_countries_service__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(services_countries_countries_service__WEBPACK_IMPORTED_MODULE_1__);




// in cloudinarry, upload both to staging and production (so you'll be able to test first)
var SUPPORTED_LOGOS_NUMBER_OPTIONS = [
    "5",
    "7",
    "9",
    "10",
    "12",
    "15",
    "18",
    "20"
];
var SUPPORTED_LOGOS_NUMBER_FOR_NARROW_DISPLAY_OPTIONS = [
    "5",
    "7",
    "9",
    "10",
    "12",
    "15",
    "18",
    "20"
];
var LOGO_COMPANY_FIELDS = {
    GENERAL: "General",
    GENERAL_WHITE: "General (white)",
    GENERAL_BLACK: "General (black)",
    GENERAL_OLD: "General_Old",
    HEALTHCARE: "Healthcare",
    ENTERTAINMENT: "Entertainment",
    MARKETING: "Marketing",
    ENTERPRISE: "Enterprise",
    SOFTWARE: "Software",
    CONSTRUCTION: "Construction",
    RETAIL: "Retail",
    CRM: "CRM"
};
var LOGO_COMPANY_COUNTRIES = {
    AUSTRALIA: "Australia",
    BRAZIL: "Brazil",
    FRANCE: "France",
    GERMANY: "Germany",
    ITALY: "Italy",
    JAPAN: "Japan",
    MEXICO: "Mexico",
    NETHERLANDS: "Netherlands",
    SEA: "SEA (South East Asia)",
    UK: "UK",
    SWITZERLAND: "Switzerland"
};
var _obj;
var ISO2_TO_LOGO_COUNTRIES_MAP = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, services_countries_countries_service__WEBPACK_IMPORTED_MODULE_1__.UNITED_KINGDOM_ISO2, LOGO_COMPANY_COUNTRIES.UK), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, services_countries_countries_service__WEBPACK_IMPORTED_MODULE_1__.AUSTRALIA_ISO2, LOGO_COMPANY_COUNTRIES.AUSTRALIA), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, services_countries_countries_service__WEBPACK_IMPORTED_MODULE_1__.PHILIPPINES_ISO2, LOGO_COMPANY_COUNTRIES.SEA), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, services_countries_countries_service__WEBPACK_IMPORTED_MODULE_1__.SINGAPORE_ISO2, LOGO_COMPANY_COUNTRIES.SEA), _obj);
var Uber = {
    url: "/static/img/customers/logos-v2/uber.png",
    name: "Uber"
};
// const Adobe = {
//   url: "/static/img/customers/logos-v2/adobe.png",
//   name: "Adobe"
// };
var UniversalMusicGroup = {
    url: "/static/img/customers/logos-v2/universal.png",
    name: "Universal Music Group"
};
var UniversalMusicGroupWhite = {
    url: "/static/img/customers/logos-v2/Logos_white/universal.png",
    name: "Universal Music Group"
};
var UniversalMusicGroupBlack = {
    url: "/static/img/customers/logos-v2/Logos_black/universal.png",
    name: "Universal Music Group"
};
// const Hulu = {
//   url: "/static/img/customers/logos-v2/hulu.png",
//   name: "Hulu"
// };
// const Unilever = {
//   url: "/static/img/customers/logos-v2/unilever.png",
//   name: "Unilever"
// };
// const Abbott = {
//   url: "/static/img/customers/logos-v2/abbott.png",
//   name: "Abbott"
// };
var Genpact = {
    url: "/static/img/customers/logos-v2/genpact.png",
    name: "Genpact"
};
// const Humana = {
//   url: "/static/img/customers/logos-v2/humana.png",
//   name: "Humana"
// };
var FrontierDevelopments = {
    url: "/static/img/customers/logos-v2/frontier-developments-seeklogo.png",
    name: "Frontier Developments"
};
var Zippo = {
    url: "/static/img/customers/logos-v2/Retail_Zippo.png",
    name: "Zippo"
};
var Alexion = {
    url: "/static/img/customers/logos-v2/alexion.png",
    name: "Alexion"
};
var Anadarko = {
    url: "/static/img/customers/logos-v2/anadarko.png",
    name: "Anadarko"
};
// const Gameloft = {
//   url: "/static/img/customers/logos-v2/gameloft.png",
//   name: "Gameloft"
// };
var Spinmaster = {
    url: "/static/img/customers/logos-v2/spinmaster.png",
    name: "Spinmaster"
};
var InteriorLogic = {
    url: "/static/img/customers/logos-v2/interior_logic.png",
    name: "Interior Logic"
};
var AmericanFamilyInsurance = {
    url: "/static/img/customers/logos-v2/american_family_insurance.png",
    name: "American Family Insurance"
};
var Deezer = {
    url: "/static/img/customers/logos-v2/deezer.png",
    name: "Deezer"
};
var Barvado = {
    url: "/static/img/customers/logos-v2/barvado.png",
    name: "Barvado"
};
var Briggs = {
    url: "/static/img/customers/logos-v2/briggs_stratton_corporation.png",
    name: "Briggs"
};
var CarndoChemrisk = {
    url: "/static/img/customers/logos-v2/cardno_chemrisk.png",
    name: "Carndo Chemrisk"
};
// const ReiCom = { url: "/static/img/customers/logos-v2/rei.com.png", name: "Reicom" };
var AeroMexico = {
    url: "/static/img/customers/logos-v2/aeromexico.png",
    name: "Aero Mexico"
};
var ProcoreTechnology = {
    url: "/static/img/customers/logos-v2/procore_technology.png",
    name: "Procore Technology"
};
// const FoxNews = { url: "/static/img/customers/logos-v2/fox_news.png", name: "Fox News" };
// const AllState = { url: "/static/img/customers/logos-v2/allstate.png", name: "Allstate" };
var Outbrain = {
    url: "/static/img/customers/logos-v2/outbrain.png",
    name: "Outbrain"
};
// const Delta = { url: "/static/img/customers/logos-v2/delta.png",  name: "Delta" };
var Emerson = {
    url: "/static/img/customers/logos-v2/emerson.png",
    name: "Emerson"
};
var CardinalHealth = {
    url: "/static/img/customers/logos-v2/cardinal_health.png",
    name: "Cardinal Health"
};
// const IBM = { url: "/static/img/customers/logos-v2/ibm.png",  name: "IBOM" };
// const WeWork = { url: "/static/img/customers/logos-v2/wework.png",  name: "WeWork" };
// const MITFederalCredit = {
//   url: "/static/img/customers/logos-v2/mit_federal_credit_union.png",
//   name: "MIT Federal Credit"
// };
var Marriott = {
    url: "/static/img/customers/logos-v2/marriott.png",
    name: "Marriott"
};
var Mckesson = {
    url: "/static/img/customers/logos-v2/mckesson.png",
    name: "Mckesson"
};
// const Corning = { url: "/static/img/customers/logos-v2/corning.png", name: "Corning" };
// const Tesla = { url: "/static/img/customers/logos-v2/tesla.png", name: "Tesla" };
// const Naic = { url: "/static/img/customers/logos-v2/naic.png", name: "Naic" };
// const Paypal = {
//   url: "/static/img/customers/logos-v2/paypal.png",
//   name: "Paypal"
// };
var Glossier = {
    url: "/static/img/customers/logos-v2/glossier.png",
    name: "Glossier"
};
var GlossierWhite = {
    url: "/static/img/customers/logos-v2/Logos_white/glossier.png",
    name: "Glossier"
};
var GlossierBlack = {
    url: "/static/img/customers/logos-v2/Logos_black/glossier.png",
    name: "Glossier"
};
var Kroger = {
    url: "/static/img/customers/logos-v2/kroger.png",
    name: "Kroger"
};
var Walmart = {
    url: "/static/img/customers/logos-v2/walmart.png",
    name: "Walmart"
};
var NipponOil = {
    url: "/static/img/customers/logos-v2/nippon_oil_corporation.png",
    name: "NipponOil"
};
// const Visa = {
//   url: "/static/img/customers/logos-v2/visa.png",
//   name: "Visa"
// };
// const CultureTrip = {
//   url: "/static/img/customers/logos-v2/culture_trip.png",
//   name: "Culture Trip"
// };
// const ClasenChocolate = {
//   url: "/static/img/customers/logos-v2/clasen_of_chocolate.png",
//   name: "Clasen Chocolate"
// };
// const Aecom = { url: "/static/img/customers/logos-v2/aecom.png", name: "Aecom" };
var ADP = {
    url: "/static/img/customers/logos-v2/adp.png",
    name: "ADP"
};
var BD = {
    url: "/static/img/customers/logos-v2/bd.png",
    name: "BD"
};
var BDWhite = {
    url: "/static/img/customers/logos-v2/Logos_white/bd.png",
    name: "BD"
};
var BDBlack = {
    url: "/static/img/customers/logos-v2/Logos_black/bd.png",
    name: "BD"
};
var HCAHealthcare = {
    url: "/static/img/customers/logos-v2/hca_healthcare.png",
    name: "HCA Healthcare"
};
var Peloton = {
    url: "/static/img/customers/logos-v2/peloton.png",
    name: "Peloton"
};
var TennisAustralia = {
    url: "/static/img/customers/logos-v2/tennis_australia.png",
    name: "Tennis Australia"
};
// const CBRE = { url: "/static/img/customers/logos-v2/cbre.png", name: "CBRE" };
var Exelon = {
    url: "/static/img/customers/logos-v2/exelon.png",
    name: "Exelon"
};
var HenrySchein = {
    url: "/static/img/customers/logos-v2/henry_schein.png",
    name: "Henry Schein"
};
var Davita = {
    url: "/static/img/customers/logos-v2/davita.png",
    name: "Davita"
};
// const Oneok = { url: "/static/img/customers/logos-v2/oneok.png", name: "Oneok" };
// const Parker = { url: "/static/img/customers/logos-v2/parker.png", name: "Parker" };
var PVH = {
    url: "/static/img/customers/logos-v2/Retail_PVH.png",
    name: "PVH"
};
// const Sempra = { url: "/static/img/customers/logos-v2/sempra.png", name: "Sampra" };
var Stryker = {
    url: "/static/img/customers/logos-v2/stryker.png",
    name: "Stryker"
};
var ThermoFisher = {
    url: "/static/img/customers/logos-v2/thermo_fisher.png",
    name: "Thermo Fisher"
};
var Univar = {
    url: "/static/img/customers/logos-v2/univar.png",
    name: "Univar"
};
var UsFoods = {
    url: "/static/img/customers/logos-v2/us_foods.png",
    name: "UsFoods"
};
var WestRock = {
    url: "/static/img/customers/logos-v2/westrock.png",
    name: "WestRock"
};
// const YUM = { url: "/static/img/customers/logos-v2/yum.png", name: "YUM" };
var Caseys = {
    url: "/static/img/customers/logos-v2/caseys.png",
    name: "Caseys"
};
// const Ascential = { url: "/static/img/customers/logos-v2/ascential.png", name: "Ascential" };
var CrossRiverBank = {
    url: "/static/img/customers/logos-v2/cross_river_bank.png",
    name: "Cross River Bank"
};
var PrimonialHolding = {
    url: "/static/img/customers/logos-v2/primonial_holding.png",
    name: "Primonial Holding"
};
var Prohibition_vapes = {
    url: "/static/img/customers/logos-v2/prohibition_vapes.png",
    name: "Prohibition Vapes"
};
var AlbericiGroup = {
    url: "/static/img/customers/logos-v2/alberici_group.png",
    name: "Alberic Group"
};
var UniversityOfLouisville = {
    url: "/static/img/customers/logos-v2/university_of_louisville.png",
    name: "University Of Louisville"
};
var GamingLabs = {
    url: "/static/img/customers/logos-v2/gaming_labs.png",
    name: "Gaming Labs"
};
var Terracon = {
    url: "/static/img/customers/logos-v2/terracon.png",
    name: "Terracon"
};
var VeriskAnalytics = {
    url: "/static/img/customers/logos-v2/verisk_analytics.png",
    name: "Verisk Analytics"
};
// const GuidWellSource = {
//   url: "/static/img/customers/logos-v2/guidewell_source.png",
//   name: "GuideWell Source"
// };
var CushmanAndWakefield = {
    url: "/static/img/customers/logos-v2/cushman_and_wakefield.png",
    name: "Cushman & Wakefield"
};
var AmericanDentalAssociation = {
    url: "/static/img/customers/logos-v2/american_dental_association.png",
    name: "American Dental Association"
};
var Transport = {
    url: "/static/img/customers/logos-v2/transport-for-greater-manchester.png",
    name: "Transport"
};
// const Web = { url: "/static/img/customers/logos-v2/web.com.png", name: "Web" };
var HamiltonLaneAdvisors = {
    url: "/static/img/customers/logos-v2/hamilton_lane_advisors.png",
    name: "Hamilton Land Advisors"
};
// const DineInFreshDbaPlated = {
//   url: "/static/img/customers/logos-v2/dineinfresh_dba_plated.png",
//   name: "DineInFresh"
// };
var SouthTexasCollege = {
    url: "/static/img/customers/logos-v2/south_texas_college.png",
    name: "South Texas College"
};
var LMBopco = {
    url: "/static/img/customers/logos-v2/lmb_opco.png",
    name: "Lmb Opco"
};
// const BBC = {
//   url: "/static/img/customers/logos-v2/bbc.png",
//   name: "BBC"
// };
// const FrankeKitchenSystems = {
//   url: "/static/img/customers/logos-v2/franke_kitchen_systems.png",
//   name: "Franke Kitchen Systems"
// };
var InsightVenturePartners = {
    url: "/static/img/customers/logos-v2/insight_venture_partners.png",
    name: "Insights Venture Partners"
};
// const Kumon = { url: "/static/img/customers/logos-v2/kumon.png", name: "Kumon" };
var LiebermanResearch = {
    url: "/static/img/customers/logos-v2/lieberman_research.png",
    name: "Lieberman Research"
};
var Novocure = {
    url: "/static/img/customers/logos-v2/novocure.png",
    name: "Novocure"
};
// const Tarkett = { url: "/static/img/customers/logos-v2/tarkett.png", name: "Tarkett" };
// const IronSource = { url: "/static/img/customers/logos-v2/ironsource.png",  name: "IronSource" };
// new country logos
var BnpParibas = {
    url: "/static/img/customers/logos-v2/bnpparibas.png",
    name: "BNP Paribas"
};
// const Bosch = {
//   url: "/static/img/customers/logos-v2/bosch.png",
//   name: "Bosch"
// };
var CocaCola = {
    url: "/static/img/customers/logos-v2/coca_cola.png",
    name: "Coca Cola"
};
var CocaColaWhite = {
    url: "/static/img/customers/logos-v2/Logos_white/cocacola.png",
    name: "Coca Cola"
};
var CocaColaBlack = {
    url: "/static/img/customers/logos-v2/Logos_black/cocacola.png",
    name: "Coca Cola"
};
var Globoplay = {
    url: "/static/img/customers/logos-v2/globoplay.png",
    name: "Globoplay"
};
var Loreal = {
    url: "/static/img/customers/logos-v2/loreal.png",
    name: "Loreal"
};
var RaiaDrogasil = {
    url: "/static/img/customers/logos-v2/raia_drogasil.png",
    name: "Raia Drogasil"
};
var Omelete = {
    url: "/static/img/customers/logos-v2/omelete.png",
    name: "Omelete"
};
var Hepmil = {
    url: "/static/img/customers/logos-v2/hempmil.png",
    name: "Hepmil"
};
var Sistic = {
    url: "/static/img/customers/logos-v2/SISTIC-Logo-PNG.png",
    name: "Sistic"
};
var NBC = {
    url: "/static/img/customers/logos-v2/nbc-logo.png",
    name: "NBC"
};
var DiscoveryChannel = {
    url: "/static/img/customers/logos-v2/discovery_channel_logo.png",
    name: "Discovery Channel"
};
var SkyBrasil = {
    url: "/static/img/customers/logos-v2/sky-brasil.jpg",
    name: "Sky Brasil"
};
var Carrefour = {
    url: "/static/img/customers/logos-v2/carrefour.png",
    name: "Carrefour"
};
var CarrefourWhite = {
    url: "/static/img/customers/logos-v2/Logos_white/carrefour.png",
    name: "Carrefour"
};
var CarrefourBlack = {
    url: "/static/img/customers/logos-v2/Logos_black/carrefour.png",
    name: "Carrefour"
};
var Sanofi = {
    url: "/static/img/customers/logos-v2/sanofi.png",
    name: "Sanofi"
};
var Accor = {
    url: "/static/img/customers/logos-v2/accor.png",
    name: "Accor"
};
var Bayer = {
    url: "/static/img/customers/logos-v2/bayer.png",
    name: "Bayer"
};
var Zhdk = {
    url: "/static/img/customers/logos-v2/zhdk.png",
    name: "Zhdk"
};
var Freitag = {
    url: "/static/img/customers/logos-v2/freitag.png",
    name: "Freitag"
};
var PicPay = {
    url: "/static/img/customers/logos-v2/picpay.png",
    name: "PicPay"
};
// const Wildlife = {
//   url: "/static/img/customers/logos-v2/wildlife.png",
//   name: "Wildlife"
// };
// const Magalu = {
//   url: "/static/img/customers/logos-v2/magalu.png",
//   name: "Magalu"
// };
// const Nubank = {
//   url: "/static/img/customers/logos-v2/nubank.png",
//   name: "Nubank"
// };
var BtgPactual = {
    url: "/static/img/customers/logos-v2/btg-pactual.png",
    name: "BtgPactual"
};
// const Ifood = {
//   url: "/static/img/customers/logos-v2/ifood.png",
//   name: "Ifood"
// };
var Wix = {
    url: "/static/img/customers/logos-v2/wix.png",
    name: "Wix"
};
var Eni = {
    url: "/static/img/customers/logos-v2/eni.png",
    name: "Eni"
};
// const Moncler = {
//   url: "/static/img/customers/logos-v2/moncler.png",
//   name: "Moncler"
// };
// const Prometeia = {
//   url: "/static/img/customers/logos-v2/prometeia.png",
//   name: "Prometeia"
// };
var AsRoma = {
    url: "/static/img/customers/logos-v2/as_roma.png",
    name: "AS Roma"
};
var RomaMobilita = {
    url: "/static/img/customers/logos-v2/mobilita.png",
    name: "Roma Mobilita"
};
var SoftwareAG = {
    url: "/static/img/customers/logos-v2/software_ag.png",
    name: "Software AG"
};
var BauerMediaGroup = {
    url: "/static/img/customers/logos-v2/bauer-media-group.png",
    name: "Bauer Media Group"
};
// const NHL = {
//   url: "/static/img/customers/logos-v2/nhl.png",
//   name: "NHL"
// };
// const Hubspot = {
//   url: "/static/img/customers/logos-v2/hubspot.png",
//   name: "Hubspot"
// };
var MarsWrigley = {
    url: "/static/img/customers/logos-v2/mars_wrigley.png",
    name: "Mars Wrigley"
};
var McCan = {
    url: "/static/img/customers/logos-v2/maccan.png",
    name: "McCan"
};
var Canva = {
    url: "/static/img/customers/logos-v2/canva.png",
    name: "Canva"
};
var CanvaWhite = {
    url: "/static/img/customers/logos-v2/Logos_white/canva.png",
    name: "Canva"
};
var CanvaBlack = {
    url: "/static/img/customers/logos-v2/Logos_black/canva.png",
    name: "Canva"
};
// const ElectronicArts = {
//   url: "/static/img/customers/logos-v2/Electronic_Arts.png",
//   name: "Electronic Arts"
// };
// const NBCUniversal = {
//   url: "/static/img/customers/logos-v2/NBCUniversal.png",
//   name: "NBC Universal"
// };
var Ebanx = {
    url: "/static/img/customers/logos-v2/ebanx.png",
    name: "Ebanx"
};
var Movile = {
    url: "/static/img/customers/logos-v2/movile.png",
    name: "Movile"
};
var Riachuelo = {
    url: "/static/img/customers/logos-v2/riachuelo.png",
    name: "Riachuelo"
};
var Even = {
    url: "/static/img/customers/logos-v2/even.png",
    name: "Even"
};
var Playtech = {
    url: "/static/img/customers/logos-v2/playtech.png",
    name: "Playtech"
};
var Datacom = {
    url: "/static/img/customers/logos-v2/datacom.png",
    name: "Datacom"
};
var Lightspeed = {
    url: "/static/img/customers/logos-v2/lightspeed.png",
    name: "Lightspeed"
};
// const Nautica = {
//   url: "/static/img/customers/logos-v2/nautica.png",
//   name: "Nautica"
// };
var Eisai = {
    url: "/static/img/customers/logos-v2/Eisai.png",
    name: "Eisai"
};
var Wella = {
    url: "/static/img/customers/logos-v2/Retail_Wella.png",
    name: "Wella"
};
var NipponGases = {
    url: "/static/img/customers/logos-v2/nippon.png",
    name: "NipponGases"
};
var HoltCat = {
    url: "/static/img/customers/logos-v2/HoltCat.png",
    name: "HoltCat"
};
var HoltCatWhite = {
    url: "/static/img/customers/logos-v2/Logos_white/Holt.png",
    name: "HoltCatWhite"
};
var HoltCatBlack = {
    url: "/static/img/customers/logos-v2/Logos_black/Holt.png",
    name: "HoltCatBlack"
};
var Falk = {
    url: "/static/img/customers/logos-v2/Falk.png",
    name: "Falk"
};
// const Motorola = {
//   url: "/static/img/customers/logos-v2/motorola.png",
//   name: "Motorola"
// };
var Aesop = {
    url: "/static/img/customers/Aesop.png",
    name: "Aesop"
};
var Levis = {
    url: "/static/img/customers/levis.png",
    name: "Levis"
};
var Carlsberg = {
    url: "/static/img/customers/carlsberg.png",
    name: "Carlsberg"
};
var Lionsgate = {
    url: "/static/img/customers/logos-v2/lionsgate.png",
    name: "Lionsgate"
};
var LionsgateWhite = {
    url: "/static/img/customers/logos-v2/Logos_white/lionsgate.png",
    name: "Lionsgate"
};
var LionsgateBlack = {
    url: "/static/img/customers/logos-v2/Logos_black/lionsgate.png",
    name: "Lionsgate"
};
var Herdez = {
    url: "/static/img/customers/logos-v2/herdez.png",
    name: "Herdez"
};
var CruzRuja = {
    url: "/static/img/customers/logos-v2/cruz_ruja.png",
    name: "Cruz Ruja"
};
// const Prosegur = {
//   url: "/static/img/customers/logos-v2/prosegur.png",
//   name: "Prosegur"
// };
var Coppel = {
    url: "/static/img/customers/logos-v2/coppel.png",
    name: "Coppel"
};
var Leboncoin = {
    url: "/static/img/customers/logos-v2/leboncoin.png",
    name: "Leboncoin"
};
var Axa = {
    url: "/static/img/customers/logos-v2/axa.png",
    name: "Axa"
};
var JakartaMRT = {
    url: "/static/img/customers/logos-v2/mrt-lakarta.png",
    name: "Jakarta MRT"
};
var Farfetch = {
    url: "/static/img/customers/logos-v2/farfetch.png",
    name: "Farfetch"
};
var PetLove = {
    url: "/static/img/customers/logos-v2/petlove.png",
    name: "PetLove"
};
var ArytonSenna = {
    url: "/static/img/customers/logos-v2/instituto_ayrton_senna.png",
    name: "Aryton Senna"
};
var Telefonica = {
    url: "/static/img/customers/logos-v2/o2_Telefonica.png",
    name: "Telefonica"
};
var Invitae = {
    url: "/static/img/customers/logos-v2/invitae.png",
    name: "Invitae"
};
var Hesta = {
    url: "/static/img/customers/logos-v2/hesta.png",
    name: "Hesta"
};
var NHS = {
    url: "/static/img/customers/logos-v2/sheffield_health.png",
    name: "NHS"
};
var DavidJones = {
    url: "/static/img/customers/logos-v2/david_jones.png",
    name: "David Jones"
};
var Kmart = {
    url: "/static/img/customers/logos-v2/kmart.png",
    name: "Kmart"
};
var Officeworks = {
    url: "/static/img/customers/logos-v2/officeworks.png",
    name: "Officeworks"
};
var NSW = {
    url: "/static/img/customers/logos-v2/nsw.png",
    name: "NSW"
};
var FlightCentre = {
    url: "/static/img/customers/logos-v2/flight_center.png",
    name: "Flight Centre"
};
var NuroBiz = {
    url: "/static/img/customers/logos-v2/nurobiz.png",
    name: "NuroBiz"
};
var Oxy = {
    url: "/static/img/customers/logos-v2/oxy.png",
    name: "Oxy"
};
var OxyWhite = {
    url: "/static/img/customers/logos-v2/Logos_white/Occidental-Petroleum-Logo_1.png",
    name: "OxyWhite"
};
var OxyBlack = {
    url: "/static/img/customers/logos-v2/Logos_black/Occidental-Petroleum-Logo_1.png",
    name: "OxyBlack"
};
var NutriAsia = {
    url: "/static/img/customers/logos-v2/nutri_asia.png",
    name: "NutriAsia"
};
var VerdantSolar = {
    url: "/static/img/customers/logos-v2/verdant_solar.png",
    name: "VerdantSolar"
};
var HMR = {
    url: "/static/img/customers/logos-v2/hmr-ph-logo.png",
    name: "HMR"
};
var Esker = {
    url: "/static/img/customers/logos-v2/esker.png",
    name: "Oxy"
};
var Takenaka = {
    url: "/static/img/customers/logos-v2/takenaka.png",
    name: "Oxy"
};
var JustCo = {
    url: "/static/img/customers/logos-v2/just_co.png",
    name: "Just Co"
};
var Icarros = {
    url: "/static/img/customers/logos-v2/icarros.png",
    name: "Icarros"
};
var Entreprenur = {
    url: "/static/img/customers/logos-v2/entrepreneur.png",
    name: "Entreprenur"
};
var Channel4 = {
    url: "/static/img/customers/logos-v2/channel_4.png",
    name: "Channel4"
};
var Nielsen = {
    url: "/static/img/customers/logos-v2/Nielsen.png",
    name: "Nielsen"
};
var WundermanThompson = {
    url: "/static/img/customers/logos-v2/Wunderman_Thompson.png",
    name: "WundermanThompson"
};
var MCSaatchi = {
    url: "/static/img/customers/logos-v2/M_C_Saatchi.png",
    name: "MCSaatchi"
};
var BustleDigitalGroup = {
    url: "/static/img/customers/logos-v2/Bustle.png",
    name: "BustleDigitalGroup"
};
var Frasers = {
    url: "/static/img/customers/logos-v2/FRAS.L.png",
    name: "Frasers"
};
var LondonBoroughOfHaringey = {
    url: "/static/img/customers/logos-v2/Haringey.png",
    name: "LondonBoroughOfHaringey"
};
var TheTravelCorporation = {
    url: "/static/img/customers/logos-v2/the-travel-corporation.png",
    name: "TheTravelCorporation"
};
var RoyalMail = {
    url: "/static/img/customers/logos-v2/Royal_Mail.png",
    name: "RoyalMail"
};
var Cover = {
    url: "/static/img/customers/logos-v2/cover.png",
    name: "Cover"
};
var Hitachi = {
    url: "/static/img/customers/logos-v2/Hitachi.png",
    name: "Hitachi"
};
var HitachiSolutions = {
    url: "/static/img/customers/logos-v2/Hitachi_logo.png",
    name: "Hitachi solutions"
};
var ED = {
    url: "/static/img/customers/logos-v2/3dpc_logo_4.png",
    name: "ED"
};
var Moneytree = {
    url: "/static/img/customers/logos-v2/Moneytree.png",
    name: "Moneytree"
};
var ToyotaConiqAlpha = {
    url: "/static/img/customers/logos-v2/Toyotaconiqalpha.png",
    name: "Toyota Coniq Alpha"
};
var Renault = {
    url: "/static/img/customers/logos-v2/renault_group.png",
    name: "Renault"
};
var Engie = {
    url: "/static/img/customers/logos-v2/engie_logo.png",
    name: "Engie"
};
var JumboSupermarkten = {
    url: "/static/img/customers/logos-v2/Jumbo.png",
    name: "Jumbo"
};
var ErasmusUniversityRotterdam = {
    url: "/static/img/customers/logos-v2/Erasmus.png",
    name: "Erasmus University Rotterdam"
};
var Webfleet = {
    url: "/static/img/customers/logos-v2/wf.png",
    name: "Webfleet"
};
var Hunkemoller = {
    url: "/static/img/customers/logos-v2/Hunkemoeller.png",
    name: "Hunkemoller"
};
var ScotchAndSoda = {
    url: "/static/img/customers/logos-v2/Scotch_Soda.png",
    name: "Scotch & Soda"
};
var RayWhite = {
    url: "/static/img/customers/logos-v2/ray-white.png",
    name: "Ray White"
};
var Flybuys = {
    url: "/static/img/customers/logos-v2/Flybuys.png",
    name: "Flybuys"
};
var Taronga = {
    url: "/static/img/customers/logos-v2/Taronga_zoo.png",
    name: "Taronga Zoo"
};
var NTT = {
    url: "/static/img/customers/logos-v2/ntt-data-logo.png",
    name: "NTT"
};
var Lixil = {
    url: "/static/img/customers/logos-v2/lixil_logo.png",
    name: "Lixil"
};
var Decathlon = {
    url: "/static/img/customers/logos-v2/Retail_Decathlon.png",
    name: "Decathlon"
};
var DavidYurman = {
    url: "/static/img/customers/logos-v2/Retail_David.png",
    name: "David Yurman"
};
var PapaJohns = {
    url: "/static/img/customers/logos-v2/papa_johns.png",
    name: "Papa Johns"
};
var SmartCamp = {
    url: "/static/img/customers/logos-v2/smartcamp-logo.png",
    name: "Smart Camp"
};
var SUNO = {
    url: "/static/img/customers/logos-v2/SUNO.png",
    name: "SUNO"
};
var SportGroup = {
    url: "/static/img/customers/logos-v2/sport_group.png",
    name: "Sports Group"
};
var WelcomeToTheJungle = {
    url: "/static/img/customers/logos-v2/wttj_logo.png",
    name: "Welcome To The Jungle"
};
var Yanmar = {
    url: "/static/img/customers/logos-v2/Yanmar_logo.png",
    name: "Yanmar"
};
var Obayashi = {
    url: "/static/img/customers/logos-v2/obayashi-logo.png",
    name: "Obayashi"
};
var COMPANIES_ASSETS = [
    Uber,
    Oxy,
    FrontierDevelopments,
    Zippo,
    Alexion,
    Anadarko,
    Spinmaster,
    InteriorLogic,
    AmericanFamilyInsurance,
    Deezer,
    Barvado,
    Briggs,
    CarndoChemrisk,
    Canva,
    Glossier,
    Lionsgate,
    AeroMexico,
    ProcoreTechnology,
    Outbrain,
    Emerson,
    CardinalHealth,
    Marriott,
    Mckesson,
    PapaJohns,
    Genpact,
    Kroger,
    Walmart,
    NipponOil,
    ADP,
    BD,
    HCAHealthcare,
    Peloton,
    TennisAustralia,
    Exelon,
    HenrySchein,
    Davita,
    PVH,
    Stryker,
    ThermoFisher,
    Univar,
    UsFoods,
    WestRock,
    Caseys,
    CrossRiverBank,
    PrimonialHolding,
    Prohibition_vapes,
    AlbericiGroup,
    UniversityOfLouisville,
    GamingLabs,
    Terracon,
    VeriskAnalytics,
    CushmanAndWakefield,
    AmericanDentalAssociation,
    Transport,
    HamiltonLaneAdvisors,
    SouthTexasCollege,
    LMBopco,
    Lionsgate,
    InsightVenturePartners,
    LiebermanResearch,
    Novocure,
    BnpParibas,
    CocaCola,
    Globoplay,
    RaiaDrogasil,
    Omelete,
    NBC,
    DiscoveryChannel,
    SkyBrasil,
    Carrefour,
    Sanofi,
    Accor,
    Bayer,
    BtgPactual,
    UniversalMusicGroup,
    Wix
];
var _obj1;
var LOGOS_BY_COUNTRIES = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, LOGO_COMPANY_COUNTRIES.BRAZIL, [
    Icarros,
    CocaCola,
    BtgPactual,
    PicPay,
    SUNO,
    RaiaDrogasil,
    PetLove,
    ArytonSenna,
    Even
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, LOGO_COMPANY_COUNTRIES.FRANCE, [
    Uber,
    WelcomeToTheJungle,
    Carrefour,
    Sanofi,
    Renault,
    Engie,
    Leboncoin,
    BnpParibas,
    CocaCola
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, LOGO_COMPANY_COUNTRIES.MEXICO, [
    Herdez,
    UniversalMusicGroup,
    CruzRuja,
    AeroMexico,
    Uber,
    CocaCola,
    Coppel
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, LOGO_COMPANY_COUNTRIES.GERMANY, [
    SoftwareAG,
    Wella,
    BauerMediaGroup,
    Uber,
    CocaCola,
    Bayer,
    Axa,
    SportGroup
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, LOGO_COMPANY_COUNTRIES.ITALY, [
    Eni,
    AsRoma,
    RomaMobilita,
    CocaCola
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, LOGO_COMPANY_COUNTRIES.JAPAN, [
    NuroBiz,
    Lixil,
    HitachiSolutions,
    NTT,
    Takenaka,
    NipponGases,
    Hitachi,
    ToyotaConiqAlpha,
    ED,
    Uber,
    Yanmar,
    Obayashi,
    Walmart,
    Canva,
    Cover,
    Eisai,
    Zippo,
    UniversalMusicGroup,
    HoltCat,
    CocaCola,
    Moneytree,
    SmartCamp
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, LOGO_COMPANY_COUNTRIES.AUSTRALIA, [
    Canva,
    RayWhite,
    DavidJones,
    Kmart,
    Officeworks,
    Taronga,
    Flybuys,
    FlightCentre,
    MCSaatchi,
    CocaCola
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, LOGO_COMPANY_COUNTRIES.SEA, [
    JakartaMRT,
    Canva,
    Sistic,
    NutriAsia,
    VerdantSolar,
    HMR,
    JustCo,
    Hepmil,
    Esker
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, LOGO_COMPANY_COUNTRIES.UK, [
    Frasers,
    Lionsgate,
    LondonBoroughOfHaringey,
    TheTravelCorporation,
    Nielsen,
    Outbrain,
    MarsWrigley,
    Bayer,
    RoyalMail
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, LOGO_COMPANY_COUNTRIES.NETHERLANDS, [
    JumboSupermarkten,
    ErasmusUniversityRotterdam,
    Webfleet,
    Hunkemoller,
    ScotchAndSoda,
    CocaCola,
    HoltCat,
    UniversalMusicGroup,
    Uber,
    Canva,
    Zippo
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, LOGO_COMPANY_COUNTRIES.SWITZERLAND, [
    Carrefour,
    Axa,
    Bayer,
    CocaCola,
    Uber,
    Wella,
    Zhdk,
    Freitag
]), _obj1);
var _obj2;
var LOGOS_BY_CLUSTER = (_obj2 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj2, LOGO_COMPANY_FIELDS.HEALTHCARE, [
    CardinalHealth,
    BD,
    HCAHealthcare,
    HenrySchein,
    Stryker,
    Invitae,
    Hesta,
    Alexion,
    NHS
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj2, LOGO_COMPANY_FIELDS.ENTERTAINMENT, [
    DiscoveryChannel,
    Entreprenur,
    NBC,
    Deezer,
    Telefonica,
    UniversalMusicGroup,
    Lionsgate,
    Channel4,
    Nielsen,
    SkyBrasil,
    BauerMediaGroup
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj2, LOGO_COMPANY_FIELDS.MARKETING, [
    CocaCola,
    McCan,
    UniversalMusicGroup,
    WundermanThompson,
    Wix,
    MarsWrigley,
    Glossier,
    Loreal,
    HoltCat,
    MCSaatchi
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj2, LOGO_COMPANY_FIELDS.ENTERPRISE, [
    Wix,
    Oxy,
    MarsWrigley,
    Canva,
    CocaCola,
    Lionsgate,
    Glossier,
    HoltCat,
    BD
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj2, LOGO_COMPANY_FIELDS.SOFTWARE, [
    Wix,
    Outbrain,
    Playtech,
    Datacom,
    Lightspeed,
    Canva
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj2, LOGO_COMPANY_FIELDS.CONSTRUCTION, [
    HoltCat,
    Falk,
    InteriorLogic,
    AlbericiGroup
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj2, LOGO_COMPANY_FIELDS.RETAIL, [
    Kmart,
    Carrefour,
    Peloton,
    Glossier,
    Wella,
    Zippo,
    PVH,
    Decathlon,
    DavidYurman,
    Officeworks,
    Levis,
    Loreal,
    Carlsberg
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj2, LOGO_COMPANY_FIELDS.GENERAL, [
    HoltCat,
    Canva,
    CocaCola,
    Oxy,
    Lionsgate,
    Carrefour,
    BD,
    Glossier,
    UniversalMusicGroup
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj2, LOGO_COMPANY_FIELDS.GENERAL_WHITE, [
    HoltCatWhite,
    CarrefourWhite,
    OxyWhite,
    CocaColaWhite,
    CanvaWhite,
    BDWhite,
    GlossierWhite,
    UniversalMusicGroupWhite,
    LionsgateWhite
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj2, LOGO_COMPANY_FIELDS.GENERAL_BLACK, [
    HoltCatBlack,
    UniversalMusicGroupBlack,
    CocaColaBlack,
    LionsgateBlack,
    CarrefourBlack,
    BDBlack,
    GlossierBlack,
    OxyBlack,
    CanvaBlack
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj2, LOGO_COMPANY_FIELDS.GENERAL_OLD, [
    Uber,
    Carrefour,
    Genpact,
    FrontierDevelopments,
    Zippo,
    Alexion,
    Anadarko
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj2, LOGO_COMPANY_FIELDS.CRM, [
    BustleDigitalGroup,
    BD,
    Canva,
    CocaCola,
    Lionsgate
]), _obj2);
var getPersonalizedLogosByVisitorCountryIfNeeded = function(companyField, country, personalizeUsingVisitorCountry, cloudfrontViewerCountry, abTests) {
    var supportedCompanyFields = [
        LOGO_COMPANY_FIELDS.GENERAL
    ];
    if (!supportedCompanyFields.includes(companyField)) {
        return country;
    }
    var fullyReleasedPersonalizedCountries = [
        services_countries_countries_service__WEBPACK_IMPORTED_MODULE_1__.UNITED_KINGDOM_ISO2,
        services_countries_countries_service__WEBPACK_IMPORTED_MODULE_1__.AUSTRALIA_ISO2,
        services_countries_countries_service__WEBPACK_IMPORTED_MODULE_1__.PHILIPPINES_ISO2,
        services_countries_countries_service__WEBPACK_IMPORTED_MODULE_1__.SINGAPORE_ISO2
    ];
    if (fullyReleasedPersonalizedCountries.includes(cloudfrontViewerCountry)) {
        return ISO2_TO_LOGO_COUNTRIES_MAP[cloudfrontViewerCountry];
    }
    // TODO: modify for CA logos test
    // const personalizedCountriesInTest = [AUSTRALIA_ISO2];
    // if (personalizedCountriesInTest.includes(cloudfrontViewerCountry)) {
    //   if (personalizeUsingVisitorCountry || shouldGetPersonalizedAuLogosTest(abTests, true)) {
    //     return ISO2_TO_LOGO_COUNTRIES_MAP[cloudfrontViewerCountry];
    //   }
    // }
    return country;
};
var getCompaniesAssets = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var country = options.country, companyField = options.companyField, personalizeUsingVisitorCountry = options.personalizeUsingVisitorCountry, cloudfrontViewerCountry = options.cloudfrontViewerCountry, abTests = options.abTests;
    var firstAssets = [];
    var selectedCountry = getPersonalizedLogosByVisitorCountryIfNeeded(companyField, country, personalizeUsingVisitorCountry, cloudfrontViewerCountry, abTests);
    if (selectedCountry && LOGOS_BY_COUNTRIES[selectedCountry]) {
        firstAssets = LOGOS_BY_COUNTRIES[selectedCountry];
    } else if (companyField && LOGOS_BY_CLUSTER[companyField]) {
        firstAssets = LOGOS_BY_CLUSTER[companyField];
    }
    return lodash_union__WEBPACK_IMPORTED_MODULE_0___default()((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(firstAssets).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(COMPANIES_ASSETS)));
};
var NUMBER_OF_COMPANIES = "9";


/***/ })

}]);